import React, { useState } from "react";
import { motion } from "framer-motion";
import { Center, Flex } from "@chakra-ui/react";
import GitHubCalendar from "react-github-calendar";
import GitHubTopLanguage from "./GithubComponents/GithubTopLanguages";
import ProjectsHeading from "./ProjectsSectionComponents/ProjectsHeading";
import ContactAnimationComponent from "./ContactSectionComponents/ContactAnimationComponent";
const Statistics = () => {
  const [isHovered, setIsHovered] = useState(false);

  const containerVariants = {
    initial: {
      width: 100,
      height: 100,
      x: 0,
      y: 0,
      borderRadius: 0,
    },
    animate: {
      width: 100,
      height: 100,
      x: 0,
      y: 0,
      borderRadius: isHovered ? "50%" : 0,
      transition: {
        duration: 2,
      },
    },
  };

  const overlayVariants = {
    initial: {
      width: 100,
      height: 100,
      x: 0,
      y: 0,
      borderRadius: "50%",
    },
    animate: {
      width: 100,
      height: 100,
      x: 0,
      y: 0,
      borderRadius: isHovered ? 0 : "50%",
      transition: {
        duration: 2,
      },
    },
  };

  return (
    <Flex direction={"column"}>
      {/*  */}
      <Flex direction={"column"} id="contact" paddingTop="30px">
        <Center mb="20px">
          <ProjectsHeading text={"Github"} />
        </Center>
      </Flex>
      {/*  */}
      <GitHubTopLanguage />
      <Flex margin={"auto"} mb={100} maxH={"80%"} maxW={"80%"}>
        <GitHubCalendar username="ak-nut-47" />
      </Flex>
    </Flex>
  );
};

export default Statistics;
